<script lang="ts">
	import Layout from "@components/layout/Layout.svelte";
	import BlogArticleCard from "../components/common/BlogArticleCard.svelte";
	import type { BlogProps } from "./BlogProps.js";

	const { articles }: BlogProps = $props();
</script>

<Layout>
	<section class="full-width py-8 md:py-12 lg:py-16">
		<div class="flex flex-col gap-8 md:gap-12 px-4 md:px-8 max-w-7xl mx-auto">
			<div class="flex flex-col gap-4 md:gap-6">
				<h1 class="text-center">Blog</h1>
				<p class="text-center text-base text-[#7D7D7D] max-w-3xl mx-auto font-normal">
					Objevte nejnovější trendy a tipy z péče o vlasy a pokožku hlavy. Přinášíme vám odborné rady a inspiraci pro
					zdravé a krásné vlasy.
				</p>
			</div>

			{#if articles.length > 0}
				<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
					{#each articles as article (article.id)}
						<BlogArticleCard {article} />
					{/each}
				</div>
			{:else}
				<div class="text-center py-12">
					<p class="text-lg text-[#7D7D7D]">Zatím zde nejsou žádné články.</p>
				</div>
			{/if}
		</div>
	</section>
</Layout>
